import { ButtonProps } from 'reactstrap'
import { colour } from '../Icon/types'

export enum buttonType {
  button = 'button',
  reset = 'reset',
  submit = 'submit'
}

export enum buttonSize {
  large = 'lg',
  small = 'sm',
}

export default interface Props {
  id?: string
  text?: string | JSX.Element | Element
  color?: colour
  block?: boolean
  dataBdd?: string
  disabled?: boolean
  loading?: boolean
  size?: buttonSize
  type?: buttonType
  right?: boolean
  children?:React.ReactNode

  className?: ButtonProps['className']
  innerRef?: ButtonProps['innerRef']
  onClick: ButtonProps['onClick']
  onMouseEnter?: ButtonProps['onMouseEnter']
  onMouseLeave?: ButtonProps['onMouseLeave']
  style?: ButtonProps['style']
  spinnerClassName?: string
  loadingColour?: colour
}
